export const newsItems = [
  {
    id: "news-deep-echo-release",
    title: "《深海回声》定档十月，导演陆行舟谈“用声音拍一部科幻片”",
    category: "电影新闻",
    date: "2026-10-12",
    author: "明明不喜欢 · 编辑部",
    image:
      "https://readdy.ai/api/search-image?query=cinematic%20underwater%20press%20still%20of%20a%20submersible%20with%20a%20glowing%20instrument%20panel%20descending%20into%20a%20dark%20blue%20deep%20ocean%20trench%2C%20documentary%20journalism%20style%20photography%2C%20moody%20atmosphere&width=800&height=500&seq=news-deep-echo&orientation=landscape",
    excerpt:
      "历时三年筹备的科幻悬疑电影《深海回声》正式宣布定档。导演陆行舟在采访中表示，这次想尝试“少一点视觉奇观，多一点听觉想象”。",
    content: [
      "备受期待的科幻悬疑电影《深海回声》日前宣布定档，将于本月底与观众见面。影片讲述一支深海探测队在数千米深处捕捉到一段来源不明的规律回声，由此揭开一场关于记忆与隐瞒的调查。",
      "导演陆行舟在采访中提到，剧组为此专门搭建了全密闭的实景舱体，并邀请声学团队参与声音设计。“我们希望观众是被‘听’进去的，而不是被画面推着走。”他说。",
      "片方同步发布了一支概念预告：整支预告几乎没有对白，只有渐强的低频回响与缓慢推进的镜头。有提前看过片的影评人评价，这是“近年最舍得在声音上花心思的国产科幻”。",
      "影片主演阵容包括沈亦白、林昭、温言等，目前预售已开启。",
    ],
    tags: ["深海回声", "定档", "科幻", "陆行舟"],
    relatedId: "movie-deep-echo",
  },
  {
    id: "news-star-ocean-premiere",
    title: "《星辰大海》开播首周口碑走高，三代人的星际旅程引发讨论",
    category: "电视剧新闻",
    date: "2026-10-10",
    author: "明明不喜欢 · 剧评组",
    image:
      "https://readdy.ai/api/search-image?query=cinematic%20space%20drama%20press%20still%20of%20a%20starship%20bridge%20crew%20watching%20a%20glowing%20star%20map%20hologram%2C%20sense%20of%20wonder%2C%20deep%20blue%20and%20cyan%20lighting%2C%20editorial%20photography%20style&width=800&height=500&seq=news-star-ocean&orientation=landscape",
    excerpt:
      "科幻剧集《星辰大海》开播首周便登上讨论榜前列，剧中“船上出生的一代人”设定，成为观众热议的焦点。",
    content: [
      "由陆星河执导的科幻冒险剧《星辰大海》本周正式开播。故事围绕人类第一支远航殖民舰队展开，船上三代人的命运随船漂流，构成了一部关于“家”的漫长寓言。",
      "剧集最受关注的是其世界观设定：乘客们在封闭的舰体内出生、长大、老去，目的地只存在于祖辈的讲述中。不少观众表示，这种“从未抵达的故乡”带来的怅然感，是近年科幻剧里少见的情感落点。",
      "制作方透露，为呈现舰船内部细节，美术团队设计了超过两百件道具与舱室图纸。目前该剧更新至第八集，评分保持在同类题材前列。",
    ],
    tags: ["星辰大海", "开播", "科幻剧", "星际"],
    relatedId: "tv-star-ocean",
  },
  {
    id: "news-market-autumn",
    title: "秋季档观察：中腰部影片崛起，观众更愿意为“类型清晰”买单",
    category: "业界动态",
    date: "2026-10-08",
    author: "明明不喜欢 · 行业组",
    image:
      "https://readdy.ai/api/search-image?query=modern%20cinema%20lobby%20interior%20with%20bright%20poster%20walls%20and%20queueing%20audience%20blurred%20in%20motion%2C%20editorial%20documentary%20photography%2C%20warm%20inviting%20lighting%2C%20clean%20composition&width=800&height=500&seq=news-market-autumn&orientation=landscape",
    excerpt:
      "本季度票房数据出炉，中低成本、类型明确的影片表现亮眼，多个案例显示，观众的决策正变得越来越“目标导向”。",
    content: [
      "随着秋季档进入尾声，一份行业观察报告指出，本季度票房结构中，中腰部影片的占比明显上升。多部制作成本并不高的作品，凭借清晰的市场定位取得了超出预期的成绩。",
      "报告认为，观众在选择影片时，越来越倾向于“知道自己要看什么”。悬疑、喜剧、家庭等类型片因为预期明确，更容易形成口碑传播的闭环。",
      "与此同时，宣发策略也在变化。越来越多的片方把资源集中在核心受众的精准触达上，而非一味追求全渠道曝光。“看得准，比看得广更重要。”一位从业者这样总结。",
    ],
    tags: ["票房", "市场观察", "类型片", "秋季档"],
    relatedId: "movie-misty-capital",
  },
  {
    id: "news-time-fold-trailer",
    title: "《时间折叠》发布终极预告，导演回应“烧脑”争议",
    category: "电影新闻",
    date: "2026-10-06",
    author: "明明不喜欢 · 编辑部",
    image:
      "https://readdy.ai/api/search-image?query=surreal%20sci-fi%20press%20still%20of%20a%20city%20skyline%20folding%20into%20overlapping%20time%20layers%20with%20amber%20glow%20and%20deep%20blue%20night%2C%20concept%20art%20editorial%20style%2C%20moody%20atmosphere&width=800&height=500&seq=news-time-fold&orientation=landscape",
    excerpt:
      "《时间折叠》释出终极预告，密集的信息量与非线性剪辑再度引发“看不看得懂”的讨论，导演陆星河对此给出回应。",
    content: [
      "科幻剧情片《时间折叠》本周发布终极预告。两分钟的预告里，同一段午后被反复呈现，细节却每次都有微妙差别，迅速在社交平台引发逐帧解析。",
      "面对“是否过于烧脑”的提问，导演陆星河回应：“我从来不觉得观众看不懂，只是需要一点点耐心。这个故事的核心其实很简单，就是一个人不肯放手。”",
      "影片讲述物理学家为挽回一场事故、反复折叠时间的故事。有评论认为，它把硬科幻的设定包裹在一个温情的内核里，是“理性与感性都照顾到了”的尝试。",
    ],
    tags: ["时间折叠", "预告片", "科幻", "烧脑"],
    relatedId: "movie-time-fold",
  },
  {
    id: "news-white-tower-medical",
    title: "《白塔医院》医疗细节获从业者点赞，剧组公布“顾问日记”",
    category: "电视剧新闻",
    date: "2026-10-05",
    author: "明明不喜欢 · 剧评组",
    image:
      "https://readdy.ai/api/search-image?query=clean%20modern%20hospital%20corridor%20press%20still%20at%20early%20morning%20with%20long%20light%20shafts%20and%20a%20distant%20medical%20team%2C%20professional%20calm%20atmosphere%2C%20soft%20blue%20and%20white%20tones%2C%20editorial%20photography&width=800&height=500&seq=news-white-tower&orientation=landscape",
    excerpt:
      "正在热播的医疗剧《白塔医院》因扎实的专业细节受到不少医护观众认可，剧组同步公开了拍摄期间整理的“医疗顾问日记”。",
    content: [
      "医疗职业剧《白塔医院》播出过半，剧中抢救流程、器械使用与病例讨论的真实感，成为观众讨论最多的话题之一。多位自称医护从业者的网友留言，称“终于有一部剧没有把手术台拍成舞台”。",
      "剧组顺势公开了一份拍摄期间整理的“医疗顾问日记”，记录了从剧本打磨到现场指导的诸多细节，包括每一场手术戏开拍前与顾问团队的逐条核对。",
      "该剧以公立医院急诊科为切口，通过大量群像故事展现医护人员的日常。主创表示，希望观众记住的不只是紧张的抢救，更是白大褂之下普通人的疲惫与坚持。",
    ],
    tags: ["白塔医院", "医疗剧", "细节", "热播"],
    relatedId: "tv-white-tower-hospital",
  },
  {
    id: "news-ip-adaptation",
    title: "IP改编进入“精细化”阶段：从抢版权到拼改编能力",
    category: "业界动态",
    date: "2026-10-03",
    author: "明明不喜欢 · 行业组",
    image:
      "https://readdy.ai/api/search-image?query=stack%20of%20screenplay%20scripts%20and%20storyboards%20on%20a%20warm%20wooden%20desk%20with%20a%20reading%20lamp%2C%20editorial%20still%20life%20photography%2C%20cozy%20professional%20atmosphere%2C%20soft%20warm%20tones&width=800&height=500&seq=news-ip-adaptation&orientation=landscape",
    excerpt:
      "曾经“得IP者得天下”的时代正在远去。多位制片人表示，如今比拼的不再是版权数量，而是能否把故事真正搬上屏幕。",
    content: [
      "过去几年，影视行业一度陷入IP版权的争夺战。而近期多位受访制片人表示，市场正在回归理性：“版权只是开始，改编才是硬仗。”",
      "一个被反复提及的现象是，同样是热门题材，改编扎实的作品往往能获得长尾口碑，而依赖原著光环、缺乏影视化转译的作品，则容易在开播后迅速“跳水”。",
      "业内普遍认为，下一阶段的竞争重点将从“抢什么”转向“怎么拍”——包括世界观搭建、人物弧光与节奏把控在内的综合能力，才是决定成败的关键。",
    ],
    tags: ["IP改编", "影视市场", "行业趋势", "制片"],
    relatedId: "tv-mountain-sea-tales",
  },
  {
    id: "news-changan-restore",
    title: "《长安夜行》4K修复重映：一夜走过一座城，也走过一个时代",
    category: "电影新闻",
    date: "2026-09-30",
    author: "明明不喜欢 · 编辑部",
    image:
      "https://readdy.ai/api/search-image?query=cinematic%20press%20still%20of%20ancient%20chinese%20city%20street%20at%20night%20with%20glowing%20red%20lanterns%20and%20wet%20stone%20pavement%2C%20low%20fog%2C%20period%20drama%20editorial%20photography%2C%20rich%20warm%20tones&width=800&height=500&seq=news-changan-restore&orientation=landscape",
    excerpt:
      "上映五年的古装剧情片《长安夜行》推出4K修复版并限量重映，许多观众借此重温那个“一夜之间”的盛唐故事。",
    content: [
      "古装剧情片《长安夜行》迎来上映五周年，片方宣布推出4K修复版进行限量重映。修复后的画面在灯会夜戏与雨巷段落中呈现出更丰富的层次。",
      "影片以一名小吏在一夜之间的行走为线索，串联起皇城、市井与曲江池畔。导演郑清和曾说，他真正想拍的“不是一座城，而是这座城里的人”。",
      "重映消息公布后，不少观众在社交平台分享当年的观影记忆。有影评人认为，这类作品的价值会随时间愈发清晰，“它把一个时代收进了一个夜晚”。",
    ],
    tags: ["长安夜行", "4K修复", "重映", "古装"],
    relatedId: "movie-changan-night",
  },
  {
    id: "news-mountain-sea-visual",
    title: "《山海奇谭》公布概念美术特辑，东方奇幻的世界观如何搭建",
    category: "电视剧新闻",
    date: "2026-09-28",
    author: "明明不喜欢 · 剧评组",
    image:
      "https://readdy.ai/api/search-image?query=fantasy%20concept%20art%20press%20still%20of%20floating%20enchanted%20islands%20above%20a%20glowing%20sea%20with%20mythical%20creatures%2C%20eastern%20mythology%20atmosphere%2C%20vivid%20deep%20blue%20and%20gold%20tones%2C%20editorial%20art%20style&width=800&height=500&seq=news-mountain-sea&orientation=landscape",
    excerpt:
      "奇幻冒险剧《山海奇谭》发布概念美术特辑，公开了从《山海图志》到荧幕世界的完整设计思路。",
    content: [
      "东方奇幻剧《山海奇谭》近日公布概念美术特辑，展示了从神话典籍到荧幕呈现的完整设计路径。特辑中，美术团队首次公开了数十张早期设定图。",
      "主创介绍，剧中的“山海之外”并非简单的堆砌奇观，而是希望每一处异境都能对应主角成长的一个阶段。“他看到的每一寸新世界，都是他自己的一部分。”美术指导这样解释。",
      "该剧以少年循着残缺《山海图志》踏上旅途为主线，目前正在热播中，相关世界观周边也同步开启预热。",
    ],
    tags: ["山海奇谭", "概念美术", "奇幻", "世界观"],
    relatedId: "tv-mountain-sea-tales",
  },
  {
    id: "news-streaming-shortform",
    title: "长视频与短内容的边界正在模糊，行业探索“追剧式”新形态",
    category: "业界动态",
    date: "2026-09-25",
    author: "明明不喜欢 · 行业组",
    image:
      "https://readdy.ai/api/search-image?query=abstract%20digital%20media%20concept%20still%20of%20glowing%20screens%20and%20streaming%20data%20streams%20in%20a%20dark%20room%2C%20editorial%20technology%20photography%2C%20deep%20blue%20and%20amber%20accents%2C%20minimal%20composition&width=800&height=500&seq=news-streaming&orientation=landscape",
    excerpt:
      "当长剧集开始尝试更短的节奏，短内容又在追求更完整的故事，两者的边界正在被重新定义。",
    content: [
      "近一年来，一个值得注意的趋势是：长视频内容开始借鉴短内容的节奏，尝试在每集留有更强的“钩子”；而部分短内容则反向学习长剧集，追求更完整的人物弧光。",
      "从业者认为，这种相互靠近并非简单的形式模仿，而是用户观看习惯变化的直接结果。“观众的耐心没有变少，只是更挑剔了，他们希望在更短时间里获得更完整的体验。”",
      "也有观点提醒，形式创新不能替代内容本身。无论长短，“讲好一个故事”始终是唯一不变的标准。",
    ],
    tags: ["流媒体", "短内容", "长视频", "行业观察"],
    relatedId: "tv-city-within",
  },
  {
    id: "news-silent-testimony-word",
    title: "《沉默的证词》释出法庭戏片段，一句台词为何让全场安静",
    category: "电影新闻",
    date: "2026-09-22",
    author: "明明不喜欢 · 编辑部",
    image:
      "https://readdy.ai/api/search-image?query=cinematic%20courtroom%20press%20still%20of%20an%20empty%20witness%20chair%20under%20a%20beam%20of%20cold%20light%20in%20a%20dark%20old%20courtroom%2C%20tense%20dramatic%20atmosphere%2C%20deep%20blue%20with%20amber%20wood%20tones&width=800&height=500&seq=news-silent-testimony&orientation=landscape",
    excerpt:
      "律政悬疑片《沉默的证词》公开了一段法庭戏片段，女主角白薇的一段独白被网友称为“全片最重的一句话”。",
    content: [
      "律政悬疑片《沉默的证词》日前公开了一段法庭戏正片片段。片段中，由白薇饰演的年轻律师在结案陈词时的一段独白，仅用一分半钟便让整段画面安静下来。",
      "据片方介绍，这场戏是全片拍摄周期中耗时最长的一场，仅走位与台词节奏就反复推敲了数十次。导演郑清和表示，法庭戏的力量不在于喊得多响，而在于“每一句话都要有重量”。",
      "影片讲述律师为唤醒一名十年前选择沉默的证人、重新审理旧案的故事，目前正在院线热映。",
    ],
    tags: ["沉默的证词", "法庭戏", "律政", "片段"],
    relatedId: "movie-silent-testimony",
  },
];